import { render, staticRenderFns } from "./namevalue-documento.vue?vue&type=template&id=58071c5b&"
import script from "./namevalue-documento.vue?vue&type=script&lang=ts&"
export * from "./namevalue-documento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports